/**
 * Resources page content: grouped by what people come to do. Edit here to add or change links.
 * Card fields: href, external (opens in a new tab), icon (emoji), color (ResCard-icon is-<color>), title, desc,
 * soon (shown greyed out as "Coming soon", not a link).
 */
const OKJAPA = 'https://okjapa.com/';
export const SECTIONS = [{
  key: 'money',
  title: 'Money and tax',
  sub: 'Pay and tax, at home and abroad',
  icon: 'fas fa-calculator',
  cards: [{
    href: '/tax-calculator',
    icon: '🧮',
    color: 'teal',
    title: 'Income Tax Calculator',
    desc: 'Take-home pay in Nigeria, the US, Canada and the UK'
  }, {
    href: '/salary-converter',
    icon: '💼',
    color: 'pink',
    title: 'Salary Converter',
    desc: 'Convert pay between currencies and pay periods'
  }, {
    href: '/business-tax',
    icon: '🏢',
    color: 'red',
    title: 'Business Tax Calculator',
    desc: 'Nigerian business tax, for residents and the diaspora'
  }]
}, {
  key: 'markets',
  title: 'Markets',
  sub: 'Shares, the naira and the economy',
  icon: 'fas fa-chart-line',
  cards: [{
    href: '/markets/ngx',
    icon: '📈',
    color: 'green',
    title: 'NGX Stock Market',
    desc: 'Share prices, biggest movers and a page for every listed company'
  }, {
    href: '/data-hub/usd_ngn',
    icon: '💵',
    color: 'navy',
    title: 'Naira Exchange Rates',
    desc: 'The naira against the dollar, pound, euro and more, with history'
  }, {
    href: '/data-hub?tab=economy',
    icon: '📊',
    color: 'blue',
    title: 'Economic Indicators',
    desc: 'Inflation, interest rates, reserves and growth'
  }, {
    href: '/commodities',
    icon: '🛢️',
    color: 'gold',
    title: 'Commodity Prices',
    desc: 'Oil, gold, cocoa, wheat and other world prices, in dollars and naira'
  }]
}, {
  key: 'nigeria',
  title: 'Nigeria',
  sub: 'States, government and industry',
  icon: 'fas fa-landmark',
  cards: [{
    href: '/data-hub',
    icon: '🗂️',
    color: 'navy',
    title: 'Nigeria Data Hub',
    desc: 'Economic, financial and social figures, with sources'
  }, {
    href: '/data-hub/states',
    icon: '🗺️',
    color: 'teal',
    title: 'States',
    desc: 'All 36 states and the FCT: leaders, rankings, revenue, resources'
  }, {
    href: '/community/governors',
    icon: '🗳️',
    color: 'purple',
    title: 'Governors',
    desc: 'Every state governor, with each state’s key figures'
  }, {
    href: '/community/kingdoms',
    icon: '👑',
    color: 'orange',
    title: 'Traditional Rulers',
    desc: 'Kingdoms and emirates by state, with their titles and rulers'
  }, {
    href: '/atlas',
    icon: '⛏️',
    color: 'gold',
    title: 'Voucha Atlas',
    desc: 'Resources, industry, ports and trade routes across West Africa'
  }, {
    href: 'https://ourlgamoni.com/',
    external: true,
    icon: '🏛️',
    color: 'red',
    title: 'Local Government Tracker',
    desc: 'LGAs, leadership, population and allocations'
  }]
}, {
  key: 'abroad',
  title: 'Moving and living abroad',
  sub: 'Plan a move, settle in, plan for later',
  icon: 'fas fa-globe-africa',
  cards: [{
    href: OKJAPA + 'japa-compass/',
    external: true,
    icon: '🧭',
    color: 'teal',
    title: 'Japa Compass',
    desc: 'Which countries fit you best, in a few minutes'
  }, {
    href: OKJAPA + 'where-will-you-stand/',
    external: true,
    icon: '🪜',
    color: 'blue',
    title: 'Where will you stand?',
    desc: 'Your likely income and standing in a new country'
  }, {
    href: OKJAPA + 'stay-or-go/',
    external: true,
    icon: '⚖️',
    color: 'purple',
    title: 'Stay or go?',
    desc: 'Staying in Nigeria and moving, side by side over the years'
  }, {
    href: OKJAPA + 'make-your-money-work/',
    external: true,
    icon: '🐷',
    color: 'pink',
    title: 'Make your money work',
    desc: 'Savings, investments and what you send home, planned together'
  }, {
    href: OKJAPA + 'where-to-retire/',
    external: true,
    icon: '🏡',
    color: 'orange',
    title: 'Where to retire',
    desc: 'Where your pension goes furthest, and what happens to it when you move'
  }, {
    href: '/data-hub/guides',
    icon: '📍',
    color: 'navy',
    title: 'Location Guides',
    desc: 'Canada, the UK and the US: who lives where, and income by group'
  }, {
    href: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/express-entry/check-score.html',
    external: true,
    icon: '🇨🇦',
    color: 'red',
    title: 'Express Entry CRS Calculator',
    desc: 'Your Comprehensive Ranking System score'
  }, {
    href: 'https://www.numbeo.com/cost-of-living/',
    external: true,
    icon: '🏙️',
    color: 'yellow',
    title: 'Cost of Living',
    desc: 'Housing, transport and groceries by city'
  }]
}, {
  key: 'community',
  title: 'Community',
  sub: 'Meet people near you and from home',
  icon: 'fas fa-users',
  cards: [{
    href: '/community',
    icon: '🤝',
    color: 'teal',
    title: 'My Community',
    desc: 'Members and discussions where you live and where you are from'
  }, {
    href: '/events',
    icon: '📅',
    color: 'purple',
    title: 'Events',
    desc: 'Meetups, talks and gatherings near you, in person and online'
  }]
}];